import type { ReactNode } from "react";

import { cn } from "@/utils/cn";

// Figma: https://www.figma.com/design/HJIp5P6tyeFrUd7ODqeWdM/-PROD--Fertility-V?node-id=4180-18927

export const SECTION_BACKGROUNDS = ["primary", "creme", "black"] as const;

export type SectionBackground = (typeof SECTION_BACKGROUNDS)[number];

type SectionProps = {
  children: ReactNode;
  background?: SectionBackground;
  /** Layout of the inner container (columns, gap). A repeated look is a variant. */
  className?: string;
};

const BACKGROUNDS: Record<SectionBackground, string> = {
  primary: "bg-ds-background-primary text-ds-text-primary",
  creme: "bg-ds-background-creme text-ds-text-primary",
  black: "bg-ds-background-black text-ds-text-white",
};

// Figma margin/margin-01 is the gutter; margin/margin-03 (the section padding) equals space-09.
// The 1440px frame width has no Figma variable (EVY-436).
const CONTAINER = cn(
  "mx-auto w-full max-w-[1440px]",
  "px-ds-margin-01 py-ds-space-09 md:px-ds-margin-01-desktop md:py-ds-space-09-desktop"
);

// Display component, no ref forwarded. See ui/README.md.
export const Section = ({
  children,
  background = "primary",
  className,
}: SectionProps) => (
  <section className={BACKGROUNDS[background]}>
    <div className={cn(CONTAINER, className)}>{children}</div>
  </section>
);
